import type { CategoryContent } from '../row.js';

export const THEORETICAL_PHYSICS: CategoryContent = {
  bscba: [
    [
      'Wat stelt de Born-regel in de kwantummechanica vast?',
      [
        'Een kans is het kwadraat van de amplitude-grootte',
        'Energie en impuls blijven altijd behouden in kwantuminteracties',
        'Elektronen bestaan als deeltjes in plaats van waarschijnlijkheidsgolven',
        'De positie van een deeltje kan alleen tot één decimaal nauwkeurig bekend zijn',
      ],
      0,
      'De Born-regel verbindt de golffunctie met meetwaarschijnlijkheden. Het is een fundamenteel postulaat dat amplitudes aan waarneembare uitkomsten koppelt.',
    ],
    [
      'Wat voorspelt Einsteins massa-energierelatie over licht?',
      [
        'Fotonen met hogere frequentie dragen evenredig meer energie',
        'Licht reist langzamer door transparante materialen omdat het massa krijgt',
        'Alle soorten straling hebben dezelfde energie ongeacht de frequentie',
        'Elektromagnetische golven kunnen geen impuls op materie uitoefenen',
      ],
      0,
      'E=mc² toont dat frequentie fotonenenergie bepaalt: E=hf. Hogere frequentie draagt meer energie per foton.',
    ],
    [
      'In de speciale relativiteit, wat gebeurt er met de tijd voor een object dat dicht bij de lichtsnelheid beweegt?',
      [
        'Tijd verstrijkt langzamer voor het bewegende object',
        'Tijd stopt volledig zodra het object half de lichtsnelheid bereikt',
        'Tijd beweegt altijd even snel voor alle waarnemers, ongeacht hun beweging',
        'Het bewegende object ervaart dat tijd sneller verstrijkt evenredig met zijn snelheid',
      ],
      0,
      'Tijddilatatie is een kernvoorspelling van speciale relativiteit: bewegende klokken lopen langzamer. Dit effect wordt sterker bij hogere snelheden.',
    ],
    [
      'Welk principe verhindert dat twee identieke elektronen dezelfde kwantumtoestand innemen?',
      [
        'Pauli\'s uitsluitingsprincipe',
        'Het onzekerheidsbeginsel',
        'Het correspondentieprincipe',
        'Het gelijkwaardigheidsbeginsel',
      ],
      0,
      'Het Pauli-uitsluitingsprincipe verbiedt identieke fermionen dezelfde kwantumgetallen te delen. Dit verklaart atoomstructuur en scheikunde.',
    ],
    [
      'Hoe steekt een deeltje bij kwantumtunneling door een barrière hoger dan zijn totale energie?',
      [
        'De golffunctie blijft niet-nul voorbij de barrière',
        'Het deeltje vertraagt tijdelijk om extra kinetische energie te verzamelen',
        'Het steekt niet door; de barrière weerkaatst altijd kwantumdeeltjes',
        'Het deeltje splitst in kleinere stukken die elk genoeg energie hebben',
      ],
      0,
      'Tunnelen treedt op omdat de golffunctie niet abrupt bij een barrière stopt. Deze vervalt exponentieel maar blijft aan de andere kant niet nul.',
    ],
    [
      'Wat is het primaire verschil tussen bosonen en fermionen?',
      [
        'Fermionen hebben half-integer spin; bosonen hebben integer spin',
        'Bosonen zijn zwaarder dan alle fermionen',
        'Fermionen bewegen sneller dan bosonen',
        'Alleen bosonen kunnen door laboratoriumapparatuur worden gedetecteerd',
      ],
      0,
      'Spin is het definiërende onderscheid: fermionen hebben spin 1/2, 3/2 enz.; bosonen hebben spin 0, 1, 2 enz. Dit bepaalt hun statistisch gedrag.',
    ],
    [
      'Hoe beperkt het onzekerheidsbeginsel van Heisenberg de gelijktijdige kennis van conjugate variabelen?',
      [
        'Positie- en impulsonzekerheid heeft een minimaal niet-nul product',
        'Positie of impuls is altijd exact nul voor elk deeltje',
        'Snelheid en versnelling kunnen niet op dezelfde dag worden gemeten',
        'Meting van één eigenschap vernietigt het deeltje, wat meting van de ander voorkomt',
      ],
      0,
      'Δx·Δp ≥ ℏ/2 toont dat positie en impuls niet beide willekeurig nauwkeurig kunnen zijn. Dit is fundamenteel voor de kwantummechanica.',
    ],
    [
      'Wat stelt superpositie in de kwantummechanica mogelijk?',
      [
        'Een systeem bestaat in meerdere toestanden tot meting',
        'Een deeltje kan op twee verschillende plaatsen tegelijk zijn',
        'Een elektron kan twee verschillende snelheden tegelijk hebben',
        'Energie kan zonder behoud worden aangemaakt en vernietigd',
      ],
      0,
      'Superpositie betekent dat een kwantumtoestand een lineaire combinatie van basistoestanden is. Bij meting stort het systeem in op één uitkomst met specifieke waarschijnlijkheden.',
    ],
    [
      'In de algemene relativiteit, wat vertegenwoordigt ruimtetijd-kromming?',
      [
        'Massa en energie krommen ruimte en tijd',
        'Een visuele weergave zonder fysieke betekenis',
        'De snelheid waarmee licht door een gebied reist',
        'De sterkte van de zwakke kernkracht in een gebied',
      ],
      0,
      'Kromming vervangt het Newtonse concept van zwaartekracht als kracht. Massa verbuigt ruimtetijd, en deeltjes volgen geodetische paden door gekromde ruimte.',
    ],
    [
      'Wat bewijst het Compton-effect?',
      [
        'Licht gedraagt zich als deeltjes met energie evenredig aan frequentie',
        'Elektronen bewegen altijd met de lichtsnelheid',
        'Materie kan elektromagnetische straling niet terugkaatsen',
        'Fotonen nemen in frequentie toe wanneer ze door elektronen worden geabsorbeerd',
      ],
      0,
      'Compton-verstrooiing toont dat fotonen impuls overbrengen zoals deeltjes: verstrooide fotonen hebben langere golflengten. Dit bevestigde het fotonconcept.',
    ],
    [
      'Hoe ontstaat kwantisering in het atoommodel van Bohr?',
      [
        'Impulsmoment kan alleen discrete veelvouden van ℏ aannemen',
        'Elektronen zijn beperkt tot bolvormige schillen zonder tussenliggende banen',
        'Atomen kunnen alleen licht bij specifieke, discrete frequenties uitzenden',
        'De atoomkern trekt elektronen aan met een kracht die met afstand toeneemt',
      ],
      0,
      'Bohr postuleerde dat impulsmoment L=nℏ waarbij n een geheel getal is. Deze kwantisering verklaart discrete energieniveaus en spectraallijnen.',
    ],
    [
      'Wat is golf-deeltjesdualiteit?',
      [
        'Materie en energie vertonen zowel golf- als deeltjesgedrag',
        'Deeltjes en golven zijn fundamenteel gescheiden entiteiten die nooit wisselwerken',
        'Deeltjes bestaan uit veel kleine trillingen die samen bewegen',
        'Alleen licht vertoont golfgedrag; materie is zuiver deeltjesachtig',
      ],
      0,
      'Objecten zoals elektronen vertonen deeltjeseigenschappen (lokalisatie, impuls) en golfeigenschappen (diffractie, interferentie). Context bepaalt welk gedrag domineert.',
    ],
    [
      'Wat stelt het relativiteitsprincipe in de speciale relativiteit?',
      [
        'De natuurwetten zijn in alle inertiaalstelsels dezelfde',
        'Alle referentieframes ondergaan identieke tijdsintervallen',
        'Snelheid is relatief, maar versnelling is absoluut',
        'De lichtsnelheid varieert afhankelijk van de beweging van de waarnemer',
      ],
      0,
      'Einsteins eerste postulaat: fysische wetten hebben identieke vorm voor alle inertiaalwaarnemers. Gecombineerd met constante lichtsnelheid, geeft dit tijddilatatie en lengtecontractie.',
    ],
    [
      'Wat is antimaterie?',
      [
        'Deeltjes identiek aan gewone materie maar met omgekeerde lading',
        'Een hypothetische vorm van materie die gewone materie op alle afstanden afstoot',
        'De lege ruimte tussen atomen en elektronen',
        'Een supersymmetrische partner van gewone materie die alleen in versnellers bestaat',
      ],
      0,
      'Antimaterie (positronen, antiprotonen, enz.) heeft tegengestelde lading maar gelijke massa. Deeltje-antideeltje paren annihileren, waarbij massa volledig in energie wordt omgezet.',
    ],
    [
      'In de kwantumveldtheorie, wat zijn kwantumvelden?',
      [
        'Velden die alle ruimte doordringen; deeltjes zijn hun excitaties',
        'Wiskundige artefacten die alleen voor gemaksberekeningen worden gebruikt',
        'Fysieke krachten die deeltjes rechtstreeks van de ene plaats naar de ander duwen',
        'Gebieden van ruimte waar het onzekerheidsbeginsel niet van toepassing is',
      ],
      0,
      'Velden zijn de basisontologie van KVT. Deeltjes ontstaan als kwanta—aangeslagen toestanden boven de grondtoestand. Elk deeltjestype stelt een uniek veld voor.',
    ],
  ],
  msc: [
    [
      'Wat bepaalt de Bell-test over theorieën van verborgen lokale variabelen?',
      [
        'Ze kunnen niet alle voorspellingen van de kwantummechanica reproduceren',
        'Ze geven een volledige beschrijving van de kwantummechanica op subatomaire schaal',
        'Ze zijn wiskundig gelijkwaardig aan de kwantummechanica maar gemakkelijker te berekenen',
        'Ze voorspellen een vaste waarde voor deeltjeskwaliteiten voor meting optreedt',
      ],
      0,
      'Bells stelling toont dat lokaal realisme in tegenspraak staat met KM-voorspellingen voor verstrengelde metingen. Experimenten schenden Bell-ongelijkheden.',
    ],
    [
      'Wat is de rol van de Lagrangiaan in klassieke en kwantumveldtheorie?',
      [
        'Hieruit volgen bewegingsvergelijkingen en behoudsgrootheden',
        'Het codeert de waarschijnlijkheidsverdeling van deeltjesposities',
        'Het meet rechtstreeks de totale energie-inhoud van een systeem',
        'Het specificeert grensvoorwaarden die deeltjes moeten vervullen',
      ],
      0,
      'De Lagrangiaan dichtheid genereert de theorie: Hamiltons principe en Noethers stelling leveren veldvergelijkingen en behoudswetten rechtstreeks uit de structuur.',
    ],
    [
      'In de Dirac-vergelijking, welke fysieke eigenschap stelt de vierde component van de spinor voor?',
      [
        'De amplitude voor antimaterie-oplossingen (negatieve energie)',
        'De waarschijnlijkheid het elektron op een bepaalde plaats aan te treffen',
        'De z-component van het baanimpulsmoment van het elektron',
        'De koppelingsterkte aan het elektromagnetische veld',
      ],
      0,
      'De Dirac-vergelijking bevat natuurlijk negatieve-energieoplossingen, geïnterpreteerd als antideeltjes (positronen). De viercomponentige spinor biedt plaats voor beide.',
    ],
    [
      'Wat behandelt renormalisatie in de kwantumveldtheorie?',
      [
        'Divergente lusintegralen, geabsorbeerd in opnieuw bepaalde parameters',
        'Het feit dat metingen altijd eindige resultaten geven terwijl theorie oneindigheid voorspelt',
        'De noodzaak om de kwantummechanica op zeer korte afstanden aan te passen',
        'Hoe de Lagrangiaan in formalisme van Hamilton wordt omgezet',
      ],
      0,
      'Lusintegralen divergeren bij hoge energieën, maar koppelingsconstanten en massa\'s lopen met schaal. Renormalisatie haalt eindige voorspellingen uit divergente uitdrukkingen.',
    ],
    [
      'Wat is de fysieke betekenis van ijksymmetrie in veldtheorie?',
      [
        'Het voorspelt het bestaan van ijkbosonen (krachtdragers)',
        'Het zorgt ervoor dat alle deeltjes in de theorie met lichtsnelheid bewegen',
        'Het elimineert de noodzaak om grensvoorwaarden in berekeningen in te stellen',
        'Het bewijst dat alle krachten zich tot zwaartekracht reduceren bij voldoende energie',
      ],
      0,
      'Ijksymmetrieën vereisen invoering van ijkvelden (fotonen, gluonen, W/Z-bosonen). Lokale symmetrieprincipes vormen basis van het Standaardmodel.',
    ],
    [
      'Wat bereikt het Higgs-mechanisme?',
      [
        'Het genereert massa voor ijkbosonen en fermionen via spontane symmetriebreking',
        'Het verklaart waarom bepaalde deeltjes sneller vervallen dan anderen',
        'Het biedt een uniforme beschrijving van zwakke en elektromagnetische wisselwerkingen',
        'Het voorspelt de elektronmassa met hoge nauwkeurigheid',
      ],
      0,
      'Spontane elektrozwakke symmetriebreking via het Higgs-veld geeft massa aan W/Z-bosonen en fermionen. De Higgs-vev (246 GeV) bepaalt de elektrozwakke schaal.',
    ],
    [
      'Wat bestuurt de koppelingsconstante in de kwantumveldtheorie?',
      [
        'De sterkte van wisselwerking tussen deeltjes',
        'Het totale impulsmoment dat door alle deeltjes wordt gedragen',
        'Het tempo waarmee deeltjes in lichtere producten vervallen',
        'Het aantal ruimtelijke dimensies dat toegankelijk voor de theorie is',
      ],
      0,
      'Koppelingssterkte (α voor QED, αs voor QCD) beheerst interactiewaarschijnlijkheden. Zwakke koppelingen laten storingsberekeningen toe; sterke koppelingen vereisen niet-storingsmethoden.',
    ],
    [
      'In de statistische mechanica, wat is de Boltzmann-verdeling?',
      [
        'Een toestandskans is evenredig aan exp(-E/kT)',
        'Het bewijst dat entropie in geïsoleerde systemen altijd toeneemt',
        'Het beschrijft hoe deeltjes willekeurig in gassen bewegen',
        'Het koppelt temperatuur aan de gemiddelde kinetische energie van deeltjes',
      ],
      0,
      'P(E)∝exp(-E/kT) beheerst thermisch evenwicht. Systemen onderzoeken toestanden gewogen door Boltzmann-factoren, waargenomen thermodynamisch gedrag.',
    ],
    [
      'Wat onderscheidt kwantumchromodynamica van kwantumelektrodynamica?',
      [
        'QCD heeft een niet-abelse SU(3)-symmetrie met opsluiting',
        'QED beschrijft massieve deeltjes terwijl QCD alleen massaloze deeltjes beschrijft',
        'QCD geldt alleen voor sterke kernkracht, QED overal',
        'QED voorspelt oneindige divergenties; QCD voorkomt deze via extra symmetrieën',
      ],
      0,
      'De SU(3)-ijksymmetrie van QCD is niet-commutatief: gluonen werken met zichzelf samen. Dit veroorzaakt asymptotische vrijheid en opsluiting.',
    ],
    [
      'Wat is asymptotische vrijheid?',
      [
        'De koppeling verzwakt bij kortere afstanden in theorieën zoals QCD',
        'Het vermogen van deeltjes om uit een potentiaalput te ontsnappen met alleen kinetische energie',
        'De eigenschap dat alle deeltjes uiteindelijk in stabiele eindproducten vervallen',
        'Het principe dat geen kracht een deeltje sneller dan licht kan versnellen',
      ],
      0,
      'Asymptotische vrijheid (ontdekt door Gross, Politzer, Wilczek) betekent dat sterke wisselwerking verzwakt op kleine afstanden. Dit verklaart waarom quarks quasi-vrij in hadronen zijn.',
    ],
    [
      'Wat is een padintegraal in Feynman-formulering?',
      [
        'Som over alle banen gewogen met fasefactoren',
        'De klassieke baan die de actiefunctionaal minimaliseert',
        'Een integraal over impulsruimte die verstrooiingsdwarsdoorsnedes berekent',
        'De verzameling Feynman-diagrammen die een proces bijdragen',
      ],
      0,
      'De padintegraal ∫𝒟φ e^(iS/ℏ) somt bijdragen van alle veldconfiguraties. Klassieke paden domineren; kwantuminterferentie tussen hen codeert waarschijnlijkheid.',
    ],
    [
      'Wat is spontane symmetriebreking?',
      [
        'De grondtoestand heeft minder symmetrie dan de Lagrangiaan',
        'Wanneer Lagrangiaantermen een bekende behoudswet schenden',
        'Wanneer kwantumfluctuaties de exacte symmetrie van een klassiek veld vernietigen',
        'Wanneer externe krachten een systeem buiten evenwicht stoten',
      ],
      0,
      'Wanneer potentiaalminima Lagrangiaansymmetrieën niet eerbiedigen, is het vacuüm asymmetrisch. Het systeem "kiest" één richting en breekt symmetrie spontaan.',
    ],
    [
      'Wat garandeert de CPT-stelling?',
      [
        'Fysische wetten zijn ongewijzigd onder gecombineerde C, P en T',
        'Energie en impuls blijven altijd behouden in kwantuminteracties',
        'Deeltjes en antideeltjes hebben identieke levensduren en vervalmodi',
        'De lichtsnelheid is hetzelfde in alle referentieframes',
      ],
      0,
      'CPT-symmetrie (afgeleid van causaliteit en Lorentz-invariantie) is een fundamentale stelling in lokale KVT. Schendingen zouden exotische fysica aangeven.',
    ],
    [
      'Wat is de rennende koppelingsconstante?',
      [
        'De koppelingsterkte die verandert met energieschaal',
        'Een constante die verschijnt in de koppeling van deeltjes aan externe velden',
        'Het tempo waarmee koppelingsterkte afneemt door deeltjesvervalling',
        'Een parameter die in de tijd varieert tijdens systeemevolutie',
      ],
      0,
      'De koppelingsterkte g(μ) hangt af van impulsschaal μ. Die van QED loopt naar kleinere waarden bij hoge energieën; die van QCD naar grotere waarden bij lage energieën.',
    ],
    [
      'In het Standaardmodel, welke rol spelen de W- en Z-bosonen?',
      [
        'Ze dragen de zwakke kernkracht over',
        'Ze dragen sterke kracht tussen quarks in hadronen',
        'Ze binden elektronen aan atoomkernen',
        'Ze verzenden zwaartekrachtaantrekking tussen massieve objecten',
      ],
      0,
      'W±- en Z-bosonen dragen smaakveranderende zwakke interacties over. Hun grote massa (~80-91 GeV) maakt zwakke interacties kortedrachtig, wat kernstabiliteit mogelijk maakt.',
    ],
  ],
  phd: [
    [
      'Wat kwantificeert de renormalisatiegroupvergelijking (bètafunctie) in asymptotisch vrije theorieën?',
      [
        'De veranderingssnelheid van koppeling met energieschaal',
        'De kansverdeling voor deeltjesposities in een kwantumveld',
        'Het tempo waarmee virtuele deeltjes in lusses ontstaan en verdwijnen',
        'De relatie tussen massa en koppelingsterkte in een theorie',
      ],
      0,
      'β(g)=dg/dln(μ) beheerst het lopen van de koppeling. Voor QCD drijft β<0 bij hoge q² de asymptotische vrijheid. Fixpunten structureren het conforme venster en het kritische gedrag.',
    ],
    [
      'Welk fysiek mechanisme onderheeft quarkopsluiting in QCD?',
      [
        'Kleurfluxbuizen hebben spanning; het scheiden van quarks maakt nieuwe paren',
        'De sterke kracht heeft oneindige bereik, bindende quarks permanent via potentiaal',
        'Quarks zijn eigenlijk samengestelde objecten van nog kleinere, nog ingeperkte constituenten',
        'Opsluiting is een benadering die breekt bij zeer hoge temperaturen',
      ],
      0,
      'De niet-abelse structuur van QCD staat opsluitende fluxbuizen toe. Het scheiden van quarks kost asymptotisch genoeg energie voor paarproductie; er vormen zich in plaats daarvan nieuwe singlets.',
    ],
    [
      'Wat is de fysieke betekenis van een topologische term in een Lagrangiaan?',
      [
        'Het draagt bij aan de actie, maar niet aan de bewegingsvergelijkingen',
        'Het beschrijft deeltjes die alleen op de grens van een systeem bestaan',
        'Het codeert informatie over het Coulomb-potentiaal in de theorie',
        'Het is een artefact van regularisatie die verdwijnt in continue limiet',
      ],
      0,
      'Topologische termen (θ-hoek in QCD) zijn totale afgeleiden; wijzigen actie door 2πn onder grote transformaties. Ze veranderen vacuümstructuur zonder klassieke bewegingsvergelijkingen.',
    ],
    [
      'Hoe ontstaan anomalieën in de kwantumveldtheorie en wat geven ze aan?',
      [
        'Klassieke symmetrieën worden op kwantumniveau gebroken door lusdiagrammen',
        'Ze zijn berekeningsfouten die verdwijnen met correcte regularisatieschema\'s',
        'Ze geven aan dat een klassieke symmetrie na kwantisering niet meer exact is',
        'Ze bewijzen dat een theorie inconsistent is en verlaten moet worden',
      ],
      0,
      'Anomalieën ontstaan wanneer fermionlusses klassieke symmetrieën breken. Het driehoekdiagram (ABB-anomalie) is centraal. Anomalie-annulering beperkt geünificeerde theorieën.',
    ],
    [
      'In effectieve veldtheorie, wat bepaalt powertellingen en organisatie van operatoren?',
      [
        'De schaalafmeting van operatoren ten opzichte van de afsnijding',
        'Het totale aantal lusses in Feynman-diagrammen die bijdragen aan een proces',
        'Of symmetrie expliciet of spontaan in de UV-theorie wordt gebroken',
        'De massahiërarchie van deeltjes in onderliggende theorie',
      ],
      0,
      'EFT-organisatiebeginsel: hogedimensionale operatoren worden onderdrukt (∼Λ^(-n)). Dit levert systematische voorspellingen onder de afsnijding op, via convergente expansies.',
    ],
    [
      'Wat is het belang van de Calabi-Yau-variëteit in stringtheorie?',
      [
        'De geometrie codeert de verdichte extra dimensies',
        'Het is een oplossing van Einsteins vergelijkingen die zwarte gaten in extra dimensies beschrijft',
        'Het bewijst dat stringtheorie de enige consistente kwantumzwaartekracht is',
        'Het toont aan dat supersymmetrie op alle energieschalen exact moet zijn',
      ],
      0,
      'Calabi-Yau (CY) drievouwdigheden bieden consistente stringcompactificaties met N=1-supersymmetrie op lage energieën. Topologie bepaalt generaties en interacties.',
    ],
    [
      'Welke rol speelt de operatorproduksuitbreiding (OPE) in conforme veldtheorie?',
      [
        'Het decomponeert nabije operatorproducten in sommen lokale operatoren',
        'Het relateert tweezesfunctie aan viersesfunctie via kruisvergelijkingen',
        'Het bewijst dat alle correlatiefuncties bepaald worden door één koppelingsconstante',
        'Het toont aan dat conforme dimensies gehele getallen moeten zijn',
      ],
      0,
      'OPE: O₁(x)O₂(0)~∑ Cᵢ(x)|x|^(Δ₁+Δ₂-Δᵢ) Oᵢ(0). Conforme invariantie bepaalt OPE-coëfficiënten; het structureert hele theorie.',
    ],
    [
      'Hoe biedt AdS/CFT-correspondentie inzicht in sterk gekoppelde ijktheorieën?',
      [
        'Het kaart sterk gekoppelde CFT op zwak gekoppelde zwaartekracht',
        'Het bewijst dat zwaartekracht en ijktheorie fundamenteel identiek zijn',
        'Het toont aan dat alle kwantumveldtheorieën gelijkwaardig zijn aan stringtheorieën',
        'Het elimineert renormalisatie noodzaak in kwantumveldtheorie',
      ],
      0,
      'AdS/CFT (Maldacena): grote-N ijktheorie ↔ stringzwaartekracht. Sterke koppeling in CFT ↔ zwakke koppeling in zwaartekracht. Dit maakt niet-perturbatieve berekeningen mogelijk.',
    ],
    [
      'Wat wordt bedoeld met asymptotische veiligheid in kwantumzwaartekracht?',
      [
        'Een ultravioletfixpunt van de zwaartekrachtskoppeling',
        'Een bewijs dat zwaartekracht op hoge energieën door materie moet worden afgeschermd',
        'De verklaring dat zwaartekracht van andere interacties ontkoppelt boven Planck-schaal',
        'Een mechanisme zwaartekrachtdeeltje voorkoming in verstrooiingsprocessen',
      ],
      0,
      'Asymptotische veiligheid (Weinberg): g(μ)→g* als μ→∞. Niet-triviaal UV-fixpunt kan zwaartekracht renormaliseerbaar maken. Blijft onbewezen maar viabel.',
    ],
    [
      'Wat stelt de Zamolodchikov c-theorema in tweedimensionale veldtheorieën vast?',
      [
        'Een functie die monotoon afneemt langs RG-stromen',
        'Dat alle tweedimensionale theorieën UV-conforme symmetrie moeten hebben',
        'Dat koppelingsconstanten nooit kunnen toenemen langs fysische evolutie',
        'Dat entropieproductie altijd anomaliecoëfficiënt moet gelijk zijn',
      ],
      0,
      'c-theorema: centrale lading neemt monotoon af onder RG-evolutie: cᵤᵥ > cᵢᵣ. Pijlt tijd op RG-niveau; geen terugkeer naar hoger c.',
    ],
    [
      'Wat is de fysieke oorsprong van zwartgatentropie in stringtheorie?',
      [
        'Degeneratie van microtoestanden dicht bij de horizont',
        'De verstrengeling entropie tussen zwartgatinterieur en buitenkant',
        'Een diep symmetrieprincipe dat entropie oppervlakte vereist',
        'Kwantumcorrecties op Einstein-Hilbert-werking dicht singulariteit',
      ],
      0,
      'Stringtheorie telt zwartgatmicrotoestanden via D-branen. Degeneratie dichtheid reproduceert S_BH=A/(4G) exact voor bepaalde zwarte gaten, bevestigt holografie.',
    ],
    [
      'Hoe geven instantonoplossingen in ijktheorie niet-perturbatieve fysica inzicht?',
      [
        'Topologisch niet-triviale configuraties die tussen vacua tunnelen',
        'Ze zijn artefacten van storingstheorie die in exacte oplossing verdwijnen',
        'Ze vertegenwoordigen virtuele deeltjes in lusdiagrammen geproduceerd',
        'Ze bewijzen dat koppelingsconstanten rationale getallen moeten zijn',
      ],
      0,
      'Instantonen: eindige-werkingconfiguraties interpoleren tussen vacua die verschillen in windingsgetal. Ze geven niet-perturbatieve bijdragen; cruciaal voor theta-afhankelijkheid.',
    ],
    [
      'Wat is het belang van modi in stringtheoriecompactificaties?',
      [
        'Scalaarvelden uit geometrische vervormingen van de verdichting',
        'Deeltjes die de zwakke kernkracht in de verdichte theorie overbrengen',
        'Extra dimensies ontoegankelijk voor fysische experimenten',
        'Wiskundige parameters beïnvloedende voorspellingen maar onwaarneembaar in beginsel',
      ],
      0,
      'Modi (grootte, vorm) parameteriseren de verdichtingsruimte. Hun vevs bepalen de ijkgroep op lage energie, de materie-inhoud en de koppelingen. Modistabilisatie is cruciaal.',
    ],
    [
      'Welke rol spelen superconforme algebra\'s in supersymmetrische theorieën?',
      [
        'Ze breiden de conforme groep uit met supersymmetrische generatoren',
        'Ze bewijzen dat supersymmetrie spontaan op lage energieën moet breken',
        'Ze elimineren alle kwantumcorrecties op Lagrangiaan',
        'Ze garanderen dat alle koppelingen op alle energieschalen eindig blijven',
      ],
      0,
      'Superconforme symmetrie (SU(2,2|N) in 4D) bevat conforme en SUSY-generatoren. Beperkt anomalieën; alle F-termen moeten in SCFT verdwijnen.',
    ],
    [
      'Wat is de bètafunctie voor scalaire koppeling λ in φ⁴ theorie op één lus?',
      [
        'β(λ)=(3λ²)/(16π²) op één lus',
        'Een negatieve hoeveelheid drijft koppeling naar nul op alle energieschalen',
        'Nul op alle lusorden, makend φ⁴ conforme theorie',
        'Evenredig met grenormaliseerde massa, niet koppeling zelf',
      ],
      0,
      'Op één lus: β=(3λ²)/(16π²)>0. De koppeling loopt naar grotere waarden bij hoge energieën (het triviale fixpunt is UV-repulsief). λ ontwikkelt een Landau-pool (de theorie breekt).',
    ],
  ],
  professor: [
    [
      'Wat is het moeras-vermoeden en waarom is het belangrijk voor stringtheoriefenomenologie?',
      [
        'Zwaartekracht-consistente EFT\'s missen vaak UV-voltooiing',
        'Het bewijst dat alle kwantumveldtheorieën in stringtheorie kunnen worden ingebed',
        'Het demonstreert dat supersymmetrie onder zwakke schaal moet breken',
        'Het elimineert donkere materienoodzaak in kosmologische modellen',
      ],
      0,
      'Moerasconjecturen (bijvoorbeeld het afstandsvermoeden, het dS-vermoeden) beperken laagenergetische EFT\'s. Ze beperken inflatie, quintessence en moduliruimtes in realistische stringmodellen.',
    ],
    [
      'Hoe zorgen het anomalypolynoom en Green-Schwarz-mechanisme voor 10D-superstringconsistentie?',
      [
        'Het anomalypolynoom ontbindt onder specifieke voorwaarden',
        'Ze elimineren supersymmetrienoodzaak in 10-dimensionale theorie',
        'Ze bewijzen dat ijkgroepen U(1)-factoren alleen moeten zijn',
        'Ze vereisen dat alle fermionen identieke massa\'s hebben',
      ],
      0,
      'Het anomalypolynoom moet verdwijnen voor consistentie. GS-mechanisme: X₈ Tr(R²)Tr(F²) annuleert via B∧X-termen. Dit bepaalt de ijkgroep (SO(32) of E₈×E₈); essentieel voor 10D-geldigheid.',
    ],
    [
      'Wat is de resurgentiestructuur in asymptotische reeksen en verband met transseries in veldtheorie?',
      [
        'Een asymptotische reeks codeert informatie over niet-perturbatieve correcties',
        'Wiskundige toeval dat perturbatieve berekeningen niet-perturbatieve resultaten reproduceren',
        'Een symmetrie die koppelingsconstante onder transformaties invariant verzekert',
        'Een mechanisme dat renormalisatie in bepaalde theorieën elimineert noodzaak',
      ],
      0,
      'Resurgentie: de transseries-structuur zet de asymptotische reeks om in exacte resultaten via Borel-resommatie. Instantonen en renormalonen verschijnen als discontinuïteiten, wat een verband legt met zwak-sterk dualiteit.',
    ],
    [
      'Hoe verlicht het Sachdev-Ye-Kitaev-model kwantumzwaartekracht in grote-N-limiet?',
      [
        'Een oplosbaar model van willekeurig gekoppelde fermionen met zwaartekrachtdual',
        'Het bewijst dat zwaartekracht zuiver klassiek is en geen kwantumbehandeling vereist',
        'Het demonstreert dat entropie in kwantumsystemen altijd toeneemt',
        'Het toont aan dat holografie alleen op theorieën met grote ijkgroepen van toepassing is',
      ],
      0,
      'SYK (grote q, willekeurige koppelingen): exact oplosbaar in de grote-N-limiet. Er bestaat een CFT-duaal; de chaosversterkingsfactor λₗ=π/β sluit aan bij zwarte gaten. AdS₂/CFT₁-paradigma.',
    ],
    [
      'Wat is M-theorie en welk bewijs ondersteunt bestaan ervan als verengd raamwerk voor stringdualiëren?',
      [
        'Een 11-dimensionale theorie die alle superstringtheorieën zou onderheffen',
        'Een zuiver wiskundige constructie zonder fysieke relevantie deeltjesfysica',
        'Een bepaalde stringtheorie-type dat alle bekende deeltjesfysica insluit',
        'Een mechanisme bewijzend zwaartekracht en kwantummechanica onverenigbaar zijn',
      ],
      0,
      'M-theorie: 11D SUGRA op lage energieën. Type II/E₈×E₈/SO(32) strings zijn limieten onder verschillende compactificaties. Dualiteitenweb (T, S, U) verbindt alles.',
    ],
    [
      'Hoe berekent men de zachte gravitonstelling en wat openbaart zij over verstrooiingsamplitudes?',
      [
        'Zachte-gravitonlimieten factoren in eenvoudige universele factoren',
        'Door limiet waar alle externe deeltjes lichtsnelheid naderen te nemen',
        'Gebruikend alleen boom-Feynman-diagrammen zonder lusecorrecties',
        'Het toont aan dat gravitonen fundamenteel verschillen van andere deeltjes',
      ],
      0,
      'Zachtstelling: A_soft(k→0)→Sₖ·A, waarbij Sₖ universeel is. Dit onthult asymptotische BMS-symmetrieën. Lusextensies: zachte/collineaire limieten beperken de IR-structuur van zwaartekracht.',
    ],
    [
      'Wat betekent trickberekening in verstrengeling-entropie en wat zijn beperkingen?',
      [
        'Het zet Zₙ=Tr(ρ^n) analytisch voort van n→1 om Sₑ te bepalen',
        'Een methode toepasbaar alleen op vrije veldtheorieën zonder interacties',
        'Een manier entropie berekenen werkend voor alle kwantumsystemen zonder uitzondering',
        'Een techniek bewijzend verstrengeling-entropie altijd volume evenredig is',
      ],
      0,
      'Replica: Zₙ als padintegraal op een n-bladige variëteit, waarna men de limiet n→1 neemt. Dit werkt voor vrije/zwak gekoppelde theorieën; bij sterke koppeling kunnen nieuwe zadelpunten optreden (hogere genus).',
    ],
    [
      'Hoe vangen braandynamica en DBI-werking niet-perturbatieve stringeffecten in D-braansystemen?',
      [
        'De DBI-werking beheerst D-braanbeweging in dynamische achtergrondvelden',
        'Ze beschrijven hoe open strings gesloten strings in verstrooiingsprocessen uitzenden',
        'Ze bewijzen dat D-branen in consistente stringtheorieën niet kunnen bestaan',
        'Ze tonen aan dat supersymmetrie exact in alle braanconfiguraties is',
      ],
      0,
      'DBI: √det(g+F); bevat terugwerking en stringcorrecties. Tachyonen signaleren instabiliteit; braan-antibraan-vernietiging bevrijdt straling. Niet-perturbatieve dynamica.',
    ],
    [
      'Wat is de Hirzebruch-handtekeningstelling en hoe beperkt zij anomalieën in spinorelektrodynamica?',
      [
        'De handtekening is gelijk aan de Dirac-operatorindex',
        'Een resultaat toont alle gekromde ruimten positieve scalairkromming moeten hebben',
        'Een stelling elimineert renormalisatie in veldtheorie noodzaak',
        'Een verklaring alle variëteiten topologische eigenschappen identiek hebben',
      ],
      0,
      'Handtekening Thm: τ(M)=∫L-genus. Voor spinoren op M⁴: chirale anomalie (8π²)⁻¹∫ Tr(F²)=η(grensterm). Dit verbindt de ijk-zwaartekrachtkoppeling aan topologie.',
    ],
    [
      'Hoe beheersten Regge-limiet en BFKL-vergelijking hogeenergie-verstrooiing in QCD?',
      [
        's→∞ bij vaste impulsoverdracht vertoont Regge-gedrag',
        'Ze gelden alleen voor elektromagnetische verstrooiing, niet sterke interacties',
        'Ze bewijzen dat verstrooiingsdwarsdoorsnedes energie altijd afnemen met',
        'Ze elimineren storingstheorie noodzaak in QCD-berekeningen',
      ],
      0,
      'Regge: elastische verstrooiing~sᵅ(t) via uitwisselingen. BFKL: resommeert ln(s)-ketens, wat αₚ~1.2>1 pommeron geeft. Dit domineert kleine-x DIS en pp→dijets bij LHC.',
    ],
    [
      'Wat is holomorfe anomalie in topologische stringtheorie en structuur openbaart zij?',
      [
        'F-termen verliezen holomorfie op genus>0',
        'Een teken topologische strings niet consistent bepaald zijn',
        'Een mechanisme maked topologische correlators nul boven boomniveau',
        'Een symmetrie beschermend stringtheorie kwantumcorrecties',
      ],
      0,
      'Holomorfe anomalie: ∂F_g/∂t̄≠0 op genus g. Dit bepaalt een recursie waarmee instantonen F(t) corrigeren. Cruciaal voor het berekenen van spiegelsymmetrische Gromov-Witten-invarianten.',
    ],
    [
      'Hoe ondervinden roosterQCD-simulaties bij eindige baryondichtheid het tekenprobleem, en welk inzicht geven ze in QCD-faseovergangen?',
      [
        'De fermionische determinant wordt complex bij μ≠0',
        'De roosterafstand moet oneindig worden verkleind om toegang te krijgen tot eindige dichtheid',
        'Het tekenprobleem is een zuiver computationeel artefact zonder fysieke betekenis',
        'Het demonstreert dat het QCD-fasediagram identiek is op alle dichtheden',
      ],
      0,
      'Tekenvraagstuk: det(D+μ) wordt complex, wat belangrijkheidsmodellering (importance sampling) onmogelijk maakt. Oplossingen: Taylor-expansie in μ, analytische voortzetting vanuit denkbeeldige μ, functionele RG. Dit brengt het QCD-fasediagram in kaart.',
    ],
    [
      'Wat betekent F-theorie als geometrisch stringcompactificatieraamwerk, en wat is de relatie met heterotische dualiteit?',
      [
        'F-theorie is een 12D-formalisme met elliptische vezelbundelgeometrie',
        'Een theorie vereist meer dan 11 fundamentele dimensies',
        'Een methode elimineert noodzaak alle andere stringdualiteiten theorie',
        'Een bewijs zwaartekracht ijkinteracties lage energieën ontkoppelt',
      ],
      0,
      'F-theorie: type IIB op K3-vezels (τ varieert). Elliptische-curvestructuur → ijkgroepen, materie via monodromie. Heterotisch duaal: E₈-bundel op K3. Geometrische unificatie.',
    ],
    [
      'Hoe verschillen infrarood-divergenties in zwaartekracht van Yang-Mills-theorie en zachte stellingen\' rol in annulering?',
      [
        'Zwaartekracht heeft zowel zachte foton- als gravitondivergenties',
        'Zwaartekracht heeft geen infrarood-divergenties vanwege lange bereik zwaartekrachtskracht',
        'Yang-Mills en zwaartekracht identieke infrarood-structuur zonder onderscheid',
        'Zachte stellingen bewijzen alle infrarood-divergenties volledig kunnen geëlimineerd worden',
      ],
      0,
      'Zwaartekracht IR: zachte graviton & foton. Zachtstelling: A_soft(E→0)→Sₖ·A vermindert divergentiegraad. Nog steeds divergent (anders EM in 4D), maar gestructureerd; asymptotisch BMS-symmetrieën.',
    ],
    [
      'Wat voorspelt gegeneraliseerde entropie (Wald-entropie) voor zwartgatthermodynamica hogerekromming-zwaartekracht?',
      [
        'S=∫ dA·∂L/∂R_abcd, correctie op Bekenstein-Hawking',
        'Het bewijst zwartegatentropie altijd exact A/(4G) ongeacht theorie is',
        'Het toont aan zwartegatten tweede thermodynamicawet schenden',
        'Het elimineert kwantummechanica noodzaak zwartegatten begrijpen',
      ],
      0,
      'Wald: S=(1/4G)∫ dA·√h·(∂L/∂R_abcd)ε^ab_cd. Bij horizon, R termen dragen bij; wijzigt κ, ε. Voor Gauss-Bonnet: S∝(A+βA²). Relevant voor hoge-E stringschaal.',
    ],
  ],
};
